import { render, staticRenderFns } from "./right-sidebar.vue?vue&type=template&id=4e6261ca"
import script from "./right-sidebar.vue?vue&type=script&lang=js"
export * from "./right-sidebar.vue?vue&type=script&lang=js"
import style0 from "./right-sidebar.vue?vue&type=style&index=0&id=4e6261ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports